import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styled, {css} from 'styled-components';

const isChecked = css`
  border: ${props => props.theme.frequencyButton.borderHover};
  box-shadow: ${props => props.theme.frequencyButton.boxShadowHover};
  background-color: ${props => props.theme.frequencyButton.backgroundColorActive};
  font-weight: ${props => props.theme.frequencyButton.fontWeightActive};
  padding: ${props => props.theme.frequencyButton?.paddingHover || props.theme.frequencyButton?.padding};

  span {
    padding-bottom: 0;
  }
`;

const Button = styled.button`
  text-overflow: clip;
  white-space: nowrap;
  overflow: ${props => props.theme.frequencyButton?.overflow || 'hidden'};
  font-family: ${props => props.theme.frequencyButton.fontFamily};
  font-size: ${props => props.theme.frequencyButton.fontSize};
  font-weight: ${props => props.theme.frequencyButton.fontWeight};
  line-height: ${props => props.theme.frequencyButton.lineHeight};
  width: ${props => props.theme.frequencyButton.width};
  height: ${props => props.theme.frequencyButton.height};
  box-sizing: border-box;
  text-align: center;
  display: inline-block;
  position: relative;
  cursor: pointer;
  user-select: none;
  border: ${props => props.theme.frequencyButton.border};
  border-radius: ${props => props.theme.frequencyButton.borderRadius};
  background-color: ${props => props.theme.frequencyButton.backgroundColor};
  padding: ${props => props.theme.frequencyButton.padding};
  margin-bottom: ${props => props.hasRibbon && props.theme.frequencyButton.ribbonReservedSpace || '0'};

  color: ${props => props.isChecked ? props.theme.frequencyButton.color : props.theme.frequencyButton.inactiveColor || '#000'};

  ${props => props.isChecked ? isChecked : null}

  &:hover {
    border: ${props => props.theme.frequencyButton.borderHover};
    box-shadow: ${props => props.theme.frequencyButton.boxShadowHover};
    padding: ${props => props.theme.frequencyButton?.paddingHover || props.theme.frequencyButton?.padding};
    color: ${props => props.theme.frequencyButton.colorHover || props.theme.frequencyButton.color};
    background-color: ${props => props.theme.frequencyButton.backgroundColorHover};

    span {
      padding-bottom: 0;
    }
  }

  &:focus {
    border: ${props => props.theme.frequencyButton.borderHover};
    box-shadow: ${props => props.theme.frequencyButton.boxShadowHover};
    padding: ${props => props.theme.frequencyButton?.paddingHover || props.theme.frequencyButton?.padding};

    span {
      padding-bottom: 0;
    }
  }
`;

const primaryColor = '#199A57';
Button.defaultProps = {
  theme: {
    frequencyButton: {
      padding: '1px 6px',
      color: primaryColor,
      fontFamily: '"Maax Bold", "Arial", "sans-serif"',
      fontSize: '18px',
      width: '94px',
      height: '78px',
      border: '1px solid #C4C4C4',
      borderRadius: '4px',
      backgroundColor: '#fff',
      backgroundColorActive: '#F3FAF6',
      borderHover: `1px solid ${primaryColor}`,
      boxShadowHover: `inset 0px 0px 0px 1px ${primaryColor}`
    }
  }
};

const Label = styled.div`
  font: inherit;
  padding: 0;
  margin: 0;
  max-width: 100%;
  max-height: 100%;
  overflow: hidden;
  text-overflow: clip;
  white-space: nowrap;
`;

const Ribbon = styled.span`
  position: ${props => props.theme.frequencyButton?.ribbonPosition || 'absolute'};
  left: 0;
  right: 0;
  bottom: ${props => props.theme.frequencyButton.ribbonBottom || '0'};
  height: ${props => props.theme.frequencyButton.ribbonHeight || '20%'};
  top: ${props => props.theme.frequencyButton.ribbonTop};
  background-color: ${props => props.theme.frequencyButton.ribbonColor || props.theme.frequencyButton.color};
  font-family: ${props => props.theme.frequencyButton.ribbonFont || '"Maax Bold", "Arial", "sans-serif"'};
  font-size: ${props => props.theme.frequencyButton.ribbonFontSize || '10px'};
  font-weight: ${props => props.theme.frequencyButton.ribbonFontWeight || 'bold'};
  font-style: ${props => props.theme.frequencyButton.ribbonFontStyle || 'normal'};
  color: ${props => props.theme.frequencyButton.ribbonTextColor || '#F3FAF6'};
  line-height: ${props => props.theme.frequencyButton.ribbonLineHeight || '0'};
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  vertical-align: middle;
  padding-bottom: ${props => props.theme.frequencyButton?.ribbonPaddingBottom || '0px'};
`;

export default class FrequencyButton extends Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
    ribbon: PropTypes.string,
    title: PropTypes.string,
    icon: PropTypes.string,
    isChecked: PropTypes.bool,
    setValue: PropTypes.func,
    validate: PropTypes.func
  };

  constructor (props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick (e) {
    e.stopPropagation();
    e.preventDefault();

    this.props.setValue(this.props.value);
    if (this.props.validate) {
      this.props.validate();
    }
  }

  render () {
    return (
      <Button
        type='button'
        key={this.props.value}
        tabIndex='0'
        onClick={this.onClick}
        title={this.props.title}
        className={this.props.isChecked ? 'isChecked' : null}
        isChecked={this.props.isChecked}
        hasRibbon={!!this.props.ribbon}>
        <Label>
          {this.props.icon && <i className={`fa ${this.props.icon}`} style={{marginRight: '4px'}}/>}
          {this.props.label}
        </Label>
        {this.props.ribbon ? <Ribbon>{this.props.ribbon}</Ribbon> : ''}
      </Button>
    );
  }
}
